import { ErrorFallback } from 'remote/global';
import { Outlet } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import * as Sentry from '@sentry/react';
import { useUIAdapterLocale } from 'api/queries/ui';
import { Toaster } from 'react-hot-toast';
import SetupGoogleMaps from './SetupGoogleMaps';
import SetupTranslations from './SetupTranslations';

function Setup() {
  const { adapterLocale } = useUIAdapterLocale();

  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
        <Toaster />
        <SetupGoogleMaps />
        <SetupTranslations />
        <Outlet />
      </LocalizationProvider>
    </Sentry.ErrorBoundary>
  );
}

export default Setup;
